import React, { useEffect } from "react";
import { Drawer, DrawerProps } from "antd";
import { useDrawer } from "us.common/context/DrawerContext";

/**
 * A wrapper component for Ant Design's `Drawer` that integrates with a global drawer state.
 *
 * This component manages a global state indicating whether any drawer is open,
 * using the `useDrawer` context. It ensures the global state is updated when the
 * drawer's visibility changes or when the drawer is closed.
 *
 * @param props - Props extending Ant Design's `DrawerProps`.
 * @returns The rendered Drawer component with enhanced global state management.
 */
const GlobalDrawer: React.FC<DrawerProps> = (props) => {
  const { visible, onClose } = props;
  const { setIsAnyDrawerOpen } = useDrawer();

  useEffect(() => {
    setIsAnyDrawerOpen(!!visible);
    return () => setIsAnyDrawerOpen(false);
  }, [visible]);

  const handleClose = (e: any) => {
    onClose?.(e);
    setIsAnyDrawerOpen(false);
  };

  return <Drawer {...props} onClose={handleClose} />;
};

export default GlobalDrawer;
